"use client"

import type React from "react"

interface URLFormProps {
  url: string
  onChange: (url: string) => void
}

const URLForm: React.FC<URLFormProps> = ({ url, onChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="url-input">Website URL:</label>
      <input
        id="url-input"
        type="url"
        value={url}
        onChange={(e) => onChange(e.target.value)}
        placeholder="https://example.com"
        className="text-input"
      />
    </div>
  )
}

export default URLForm
